export default [
  {
    unicode: '\u00C0',
    name: 'Latin Capital Letter A with grave',
    group: 'Vowels',
  },
  {
    unicode: '\u00E0',
    name: 'Latin Small Letter A with grave',
    group: 'Vowels',
  },
  {
    unicode: '\u00C1',
    name: 'Latin Capital letter A with acute',
    group: 'Vowels',
  },
  {
    unicode: '\u00E1',
    name: 'Latin Small Letter A with acute',
    group: 'Vowels',
  },
  {
    unicode: '\u00C2',
    name: 'Latin Capital letter A with circumflex',
    group: 'Vowels',
  },
  {
    unicode: '\u00E2',
    name: 'Latin Small Letter A with circumflex',
    group: 'Vowels',
  },
  {
    unicode: '\u00C4',
    name: 'Latin Capital letter A with diaeresis',
    group: 'Vowels',
  },
  {
    unicode: '\u00E4',
    name: 'Latin Small Letter A with diaeresis',
    group: 'Vowels',
  },
  {
    unicode: '\u00C3',
    name: 'Latin Capital letter A with tilde',
    group: 'Vowels',
  },
  {
    unicode: '\u00E3',
    name: 'Latin Small Letter A with tilde',
    group: 'Vowels',
  },
  {
    unicode: '\u00C5',
    name: 'Latin Capital letter A with ring above',
    group: 'Vowels',
  },
  {
    unicode: '\u00E5',
    name: 'Latin Small Letter A with ring above',
    group: 'Vowels',
  },
  { unicode: '\u00C6', name: 'Latin Capital letter AE', group: 'Vowels' },
  { unicode: '\u00E6', name: 'Latin Small Letter AE', group: 'Vowels' },
  {
    unicode: '\u0100',
    name: 'Latin Capital Letter A with macron',
    group: 'Vowels',
  },
  {
    unicode: '\u0101',
    name: 'Latin Small Letter A with macron',
    group: 'Vowels',
  },
  {
    unicode: '\u01CD',
    name: 'Latin Capital Letter A with caron',
    group: 'Vowels',
  },
  {
    unicode: '\u01CE',
    name: 'Latin Small Letter A with caron',
    group: 'Vowels',
  },
  {
    unicode: '\u0104',
    name: 'Latin Capital Letter A with ogonek',
    group: 'Vowels',
  },
  {
    unicode: '\u0105',
    name: 'Latin Small Letter A with ogonek',
    group: 'Vowels',
  },
  // { unicode: '\u0102', name: 'Latin Capital Letter A with breve', group: 'Vowels' },
  // { unicode: '\u0103', name: 'Latin Small Letter A with breve', group: 'Vowels' },

  {
    unicode: '\u00C8',
    name: 'Latin Capital letter E with grave',
    group: 'Vowels',
  },
  {
    unicode: '\u00E8',
    name: 'Latin Small Letter E with grave',
    group: 'Vowels',
  },
  {
    unicode: '\u00C9',
    name: 'Latin Capital Letter E with acute',
    group: 'Vowels',
  },
  {
    unicode: '\u00E9',
    name: 'Latin Small Letter E with acute',
    group: 'Vowels',
  },
  {
    unicode: '\u00CA',
    name: 'Latin Capital letter E with circumflex',
    group: 'Vowels',
  },
  {
    unicode: '\u00EA',
    name: 'Latin Small Letter E with circumflex',
    group: 'Vowels',
  },
  {
    unicode: '\u00CB',
    name: 'Latin Capital Letter E with diaeresis',
    group: 'Vowels',
  },
  {
    unicode: '\u00EB',
    name: 'Latin Small Letter E with diaeresis',
    group: 'Vowels',
  },
  {
    unicode: '\u0112',
    name: 'Latin Capital Letter E with macron',
    group: 'Vowels',
  },
  {
    unicode: '\u0113',
    name: 'Latin Small Letter E with macron',
    group: 'Vowels',
  },
  {
    unicode: '\u011A',
    name: 'Latin Capital Letter E with caron',
    group: 'Vowels',
  },
  {
    unicode: '\u011B',
    name: 'Latin Small Letter E with caron',
    group: 'Vowels',
  },
  {
    unicode: '\u0118',
    name: 'Latin Capital Letter E with ogonek',
    group: 'Vowels',
  },
  {
    unicode: '\u0119',
    name: 'Latin Small Letter E with ogonek',
    group: 'Vowels',
  },
  // { unicode: '\u0114', name: 'Latin Capital Letter E with breve', group: 'Vowels' },
  // { unicode: '\u0115', name: 'Latin Small Letter E with breve', group: 'Vowels' },
  // { unicode: '\u0116', name: 'Latin Capital Letter E with dot above', group: 'Vowels' },
  // { unicode: '\u0117', name: 'Latin Small Letter E with dot above', group: 'Vowels' },

  {
    unicode: '\u00CC',
    name: 'Latin Capital letter I with grave',
    group: 'Vowels',
  },
  {
    unicode: '\u00EC',
    name: 'Latin Small letter I with grave',
    group: 'Vowels',
  },
  {
    unicode: '\u00CD',
    name: 'Latin Capital letter I with acute',
    group: 'Vowels',
  },
  {
    unicode: '\u00ED',
    name: 'Latin Small letter I with acute',
    group: 'Vowels',
  },
  {
    unicode: '\u00CE',
    name: 'Latin Capital Letter I with circumflex',
    group: 'Vowels',
  },
  {
    unicode: '\u00EE',
    name: 'Latin Small Letter I with circumflex',
    group: 'Vowels',
  },
  {
    unicode: '\u00CF',
    name: 'Latin Capital letter I with diaeresis',
    group: 'Vowels',
  },
  {
    unicode: '\u00EF',
    name: 'Latin Small Letter I with diaeresis',
    group: 'Vowels',
  },
  {
    unicode: '\u012A',
    name: 'Latin Capital Letter I with macron',
    group: 'Vowels',
  },
  {
    unicode: '\u012B',
    name: 'Latin Small Letter I with macron',
    group: 'Vowels',
  },
  {
    unicode: '\u01CF',
    name: 'Latin Capital Letter I with caron',
    group: 'Vowels',
  },
  {
    unicode: '\u01D0',
    name: 'Latin Small Letter I with caron',
    group: 'Vowels',
  },
  {
    unicode: '\u0130',
    name: 'Latin Capital Letter I with dot above',
    group: 'Vowels',
  },
  { unicode: '\u0131', name: 'Latin Small Letter dotless I', group: 'Vowels' },

  {
    unicode: '\u00D2',
    name: 'Latin Capital letter O with grave',
    group: 'Vowels',
  },
  {
    unicode: '\u00F2',
    name: 'Latin Small Letter O with grave',
    group: 'Vowels',
  },
  {
    unicode: '\u00D3',
    name: 'Latin Capital letter O with acute',
    group: 'Vowels',
  },
  {
    unicode: '\u00F3',
    name: 'Latin Small Letter O with acute',
    group: 'Vowels',
  },
  {
    unicode: '\u0150',
    name: 'Latin Capital Letter O with double acute',
    group: 'Vowels',
  },
  {
    unicode: '\u0151',
    name: 'Latin Small Letter O with double acute',
    group: 'Vowels',
  },
  {
    unicode: '\u00D8',
    name: 'Latin Capital letter O with stroke',
    group: 'Vowels',
  },
  {
    unicode: '\u00F8',
    name: 'Latin Small Letter O with stroke',
    group: 'Vowels',
  },
  {
    unicode: '\u00D4',
    name: 'Latin Capital letter O with circumflex',
    group: 'Vowels',
  },
  {
    unicode: '\u00F4',
    name: 'Latin Small Letter O with circumflex',
    group: 'Vowels',
  },
  {
    unicode: '\u00D6',
    name: 'Latin Capital letter O with diaeresis',
    group: 'Vowels',
  },
  {
    unicode: '\u00F6',
    name: 'Latin Small Letter O with diaeresis',
    group: 'Vowels',
  },
  {
    unicode: '\u00D5',
    name: 'Latin Capital letter O with tilde',
    group: 'Vowels',
  },
  {
    unicode: '\u00F5',
    name: 'Latin Small Letter O with tilde',
    group: 'Vowels',
  },
  {
    unicode: '\u014C',
    name: 'Latin Capital Letter O with macron',
    group: 'Vowels',
  },
  {
    unicode: '\u014D',
    name: 'Latin Small Letter O with macron',
    group: 'Vowels',
  },
  {
    unicode: '\u01D1',
    name: 'Latin Capital Letter O with caron',
    group: 'Vowels',
  },
  {
    unicode: '\u01D2',
    name: 'Latin Small Letter O with caron',
    group: 'Vowels',
  },
  {
    unicode: '\u01EA',
    name: 'Latin Capital Letter O with ogonek',
    group: 'Vowels',
  },
  {
    unicode: '\u01EB',
    name: 'Latin Small Letter O with ogonek',
    group: 'Vowels',
  },

  { unicode: '\u0152', name: 'Latin Capital Ligature OE', group: 'Vowels' },
  { unicode: '\u0153', name: 'Latin Small Ligature OE', group: 'Vowels' },
  {
    unicode: '\u00D9',
    name: 'Latin Capital Letter U with grave',
    group: 'Vowels',
  },
  {
    unicode: '\u00F9',
    name: 'Latin Small Letter U with grave',
    group: 'Vowels',
  },
  {
    unicode: '\u00DA',
    name: 'Latin Capital Letter U with acute',
    group: 'Vowels',
  },
  {
    unicode: '\u00FA',
    name: 'Latin Small Letter U with acute',
    group: 'Vowels',
  },
  {
    unicode: '\u0170',
    name: 'Latin Capital Letter U with double acute',
    group: 'Vowels',
  },
  {
    unicode: '\u0171',
    name: 'Latin Small Letter U with double acute',
    group: 'Vowels',
  },
  {
    unicode: '\u00DB',
    name: 'Latin Capital Letter U with circumflex',
    group: 'Vowels',
  },
  {
    unicode: '\u00FB',
    name: 'Latin Small Letter U with circumflex',
    group: 'Vowels',
  },
  {
    unicode: '\u00DC',
    name: 'Latin Capital Letter U with diaeresis',
    group: 'Vowels',
  },
  {
    unicode: '\u00FC',
    name: 'Latin Small Letter U with diaeresis',
    group: 'Vowels',
  },
  {
    unicode: '\u016E',
    name: 'Latin Capital Letter U with ring above',
    group: 'Vowels',
  },
  {
    unicode: '\u016F',
    name: 'Latin Small Letter U with ring above',
    group: 'Vowels',
  },
  {
    unicode: '\u016A',
    name: 'Latin Capital Letter U with macron',
    group: 'Vowels',
  },
  {
    unicode: '\u016B',
    name: 'Latin Small Letter U with macron',
    group: 'Vowels',
  },
  {
    unicode: '\u01D3',
    name: 'Latin Capital Letter U with caron',
    group: 'Vowels',
  },
  {
    unicode: '\u01D4',
    name: 'Latin Small Letter U with caron',
    group: 'Vowels',
  },
  {
    unicode: '\u0172',
    name: 'Latin Capital Letter U with ogonek',
    group: 'Vowels',
  },
  {
    unicode: '\u0173',
    name: 'Latin Small Letter U with ogonek',
    group: 'Vowels',
  },

  {
    unicode: '\u00DD',
    name: 'Latin Capital Letter Y with acute',
    group: 'Vowels',
  },
  {
    unicode: '\u00FD',
    name: 'Latin Small Letter Y with acute',
    group: 'Vowels',
  },

  {
    unicode: '\u0042\u0324',
    name: 'Latin Capital Letter B with diaeresis below',
    group: 'Consonants',
  },
  {
    unicode: '\u0062\u0324',
    name: 'Latin Small Letter B with diaeresis below',
    group: 'Consonants',
  },
  // { unicode: '\u0180', name: 'Latin Small Letter B with stroke', group: 'Consonants' },
  // { unicode: '\u0181', name: 'Latin Capital Letter B with hook', group: 'Consonants' },
  // { unicode: '\u0182', name: 'Latin Capital Letter B with top bar', group: 'Consonants' },
  // { unicode: '\u0183', name: 'Latin Small Letter B with top bar', group: 'Consonants' },

  {
    unicode: '\u00C7',
    name: 'Latin Capital Letter C with cedilla',
    group: 'Consonants',
  },
  {
    unicode: '\u00E7',
    name: 'Latin Small Letter C with cedilla',
    group: 'Consonants',
  },
  {
    unicode: '\u0106',
    name: 'Latin Capital Letter C with acute',
    group: 'Consonants',
  },
  {
    unicode: '\u0107',
    name: 'Latin Small Letter C with acute',
    group: 'Consonants',
  },
  {
    unicode: '\u0108',
    name: 'Latin Capital Letter C with circumflex',
    group: 'Consonants',
  },
  {
    unicode: '\u0109',
    name: 'Latin Small Letter C with circumflex',
    group: 'Consonants',
  },
  {
    unicode: '\u010C',
    name: 'Latin Capital Letter C with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u010D',
    name: 'Latin Small Letter C with caron',
    group: 'Consonants',
  },
  // { unicode: '\u010A', name: 'Latin Capital Letter C with dot above', group: 'Consonants' },
  // { unicode: '\u010B', name: 'Latin Small Letter C with dot above', group: 'Consonants' },
  // { unicode: '\u0188', name: 'Latin Small Letter C with hook', group: 'Consonants' },
  // { unicode: '\u0187', name: 'Latin Capital Letter C with hook', group: 'Consonants' },

  {
    unicode: '\u010E',
    name: 'Latin Capital Letter D with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u010F',
    name: 'Latin Small Letter D with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u0110',
    name: 'Latin Capital Letter D with stroke',
    group: 'Consonants',
  },
  {
    unicode: '\u0111',
    name: 'Latin Small Letter D with stroke',
    group: 'Consonants',
  },
  // { unicode: '\u0189', name: 'Latin Capital Letter African D', group: 'Consonants' },
  {
    unicode: '\u1E0C',
    name: 'Latin Capital Letter D with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E0D',
    name: 'Latin Small Letter D with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u0044\u0331',
    name: 'Latin Capital Letter D with macron below',
    group: 'Consonants',
  },
  {
    unicode: '\u0064\u0331',
    name: 'Latin Small Letter D with macron below',
    group: 'Consonants',
  },
  {
    unicode: '\u0044\u0324',
    name: 'Latin Capital Letter D with diaeresis below',
    group: 'Consonants',
  },
  {
    unicode: '\u0064\u0324',
    name: 'Latin Small Letter D with diaeresis below',
    group: 'Consonants',
  },
  // { unicode: '\u018A', name: 'Latin Capital Letter D with hook', group: 'Consonants' },
  // { unicode: '\u018B', name: 'Latin Capital Letter D with top bar', group: 'Consonants' },
  // { unicode: '\u018C', name: 'Latin Small Letter D with top bar', group: 'Consonants' },

  {
    unicode: '\u01E6',
    name: 'Latin Capital Letter G with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u01E7',
    name: 'Latin Small Letter G with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u0120',
    name: 'Latin Capital Letter G with dot above',
    group: 'Consonants',
  },
  {
    unicode: '\u0121',
    name: 'Latin Small Letter G with dot above',
    group: 'Consonants',
  },
  {
    unicode: '\u1E20',
    name: 'Latin Capital Letter G with macron',
    group: 'Consonants',
  },
  {
    unicode: '\u1E21',
    name: 'Latin Small Letter G with macron',
    group: 'Consonants',
  },
  {
    unicode: '\u011E',
    name: 'Latin Capital Letter G with breve',
    group: 'Consonants',
  },
  {
    unicode: '\u011F',
    name: 'Latin Small Letter G with breve',
    group: 'Consonants',
  },
  // { unicode: '\u011C', name: 'Latin Capital Letter G with circumflex', group: 'Consonants' },
  // { unicode: '\u011D', name: 'Latin Small Letter G with circumflex', group: 'Consonants' },

  {
    unicode: '\u1E24',
    name: 'Latin Capital Letter H with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E25',
    name: 'Latin Small Letter H with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u0048\u032C',
    name: 'Latin Capital Letter H with caron below',
    group: 'Consonants',
  },
  {
    unicode: '\u0068\u032C',
    name: 'Latin Small Letter H with caron below',
    group: 'Consonants',
  },

  {
    unicode: '\u004A\u0301',
    name: 'Latin Capital Letter J with acute',
    group: 'Consonants',
  },
  {
    unicode: '\u006A\u0301',
    name: 'Latin Small Letter J with acute',
    group: 'Consonants',
  },

  {
    unicode: '\u1E32',
    name: 'Latin Capital Letter K with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E33',
    name: 'Latin Small Letter K with dot below',
    group: 'Consonants',
  },

  {
    unicode: '\u0141',
    name: 'Latin Capital Letter L with stroke',
    group: 'Consonants',
  },
  {
    unicode: '\u0142',
    name: 'Latin Small Letter L with stroke',
    group: 'Consonants',
  },
  {
    unicode: '\u1E36',
    name: 'Latin Capital Letter L with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E37',
    name: 'Latin Small Letter L with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E3A',
    name: 'Latin Capital Letter L with line below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E3B',
    name: 'Latin Small Letter L with line below',
    group: 'Consonants',
  },
  {
    unicode: '\u004C\u0324',
    name: 'Latin Capital Letter L with two dots below',
    group: 'Consonants',
  },
  {
    unicode: '\u006C\u0324',
    name: 'Latin Small Letter L with two dots below',
    group: 'Consonants',
  },

  {
    unicode: '\u1E40',
    name: 'Latin Capital Letter M with dot above',
    group: 'Consonants',
  },
  {
    unicode: '\u1E41',
    name: 'Latin Small Letter M with dot above',
    group: 'Consonants',
  },
  {
    unicode: '\u1E42',
    name: 'Latin Capital Letter M with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E43',
    name: 'Latin Small Letter M with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u004D\u0310',
    name: 'Latin Capital Letter M with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u006D\u0310',
    name: 'Latin Small Letter M with dot below',
    group: 'Consonants',
  },

  {
    unicode: '\u00D1',
    name: 'Latin Capital Letter N with tilde',
    group: 'Consonants',
  },
  {
    unicode: '\u00F1',
    name: 'Latin Small Letter N with tilde',
    group: 'Consonants',
  },
  {
    unicode: '\u0143',
    name: 'Latin Capital Letter N with acute',
    group: 'Consonants',
  },
  {
    unicode: '\u0144',
    name: 'Latin Small Letter N with acute',
    group: 'Consonants',
  },
  {
    unicode: '\u0147',
    name: 'Latin Capital Letter N with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u0148',
    name: 'Latin Small Letter N with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u1E44',
    name: 'Latin Capital Letter N with dot above',
    group: 'Consonants',
  },
  {
    unicode: '\u1E45',
    name: 'Latin Small Letter N with dot above',
    group: 'Consonants',
  },
  {
    unicode: '\u1E46',
    name: 'Latin Capital Letter N with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E47',
    name: 'Latin Small Letter N with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E48',
    name: 'Latin Capital Letter N with line below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E49',
    name: 'Latin Small Letter N with line below',
    group: 'Consonants',
  },

  {
    unicode: '\u0158',
    name: 'Latin Capital Letter R with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u0159',
    name: 'Latin Small Letter R with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u1E5E',
    name: 'Latin Capital Letter R with macron below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E5F',
    name: 'Latin Small Letter R with macron below',
    group: 'Consonants',
  },
  {
    unicode: '\u0156',
    name: 'Latin Capital Letter R with cedilla',
    group: 'Consonants',
  },
  {
    unicode: '\u0157',
    name: 'Latin Small Letter R with cedilla',
    group: 'Consonants',
  },
  {
    unicode: '\u1E58',
    name: 'Latin Capital Letter R with dot above',
    group: 'Consonants',
  },
  {
    unicode: '\u1E59',
    name: 'Latin Small Letter R with dot above',
    group: 'Consonants',
  },
  {
    unicode: '\u1E5C',
    name: 'Latin Capital Letter R with dot below and macron',
    group: 'Consonants',
  },
  {
    unicode: '\u1E5D',
    name: 'Latin Small Letter R with dot below and macron',
    group: 'Consonants',
  },

  {
    unicode: '\u015A',
    name: 'Latin Capital Letter S with acute',
    group: 'Consonants',
  },
  {
    unicode: '\u015B',
    name: 'Latin Small Letter S with acute',
    group: 'Consonants',
  },
  {
    unicode: '\u015E',
    name: 'Latin Capital Letter S with cedilla',
    group: 'Consonants',
  },
  {
    unicode: '\u015F',
    name: 'Latin Small Letter S with cedilla',
    group: 'Consonants',
  },
  {
    unicode: '\u0160',
    name: 'Latin Capital Letter S with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u0161',
    name: 'Latin Small Letter S with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u0218',
    name: 'Latin Capital Letter S with comma below',
    group: 'Consonants',
  },
  {
    unicode: '\u0219',
    name: 'Latin Small Letter S with comma below',
    group: 'Consonants',
  },
  {
    unicode: '\u00DF',
    name: 'Latin Small Letter sharp S',
    group: 'Consonants',
  },

  {
    unicode: '\u0162',
    name: 'Latin Capital Letter T with cedilla',
    group: 'Consonants',
  },
  {
    unicode: '\u0163',
    name: 'Latin Small Letter T with cedilla',
    group: 'Consonants',
  },
  {
    unicode: '\u0164',
    name: 'Latin Capital Letter T with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u0165',
    name: 'Latin Small Letter T with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u021A',
    name: 'Latin Capital Letter T with comma below',
    group: 'Consonants',
  },
  {
    unicode: '\u021B',
    name: 'Latin Small Letter T with comma below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E6E',
    name: 'Latin Capital Letter T with bar below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E6F',
    name: 'Latin Small Letter T with bar below',
    group: 'Consonants',
  },
  {
    unicode: '\u0054\u0324',
    name: 'Latin Capital Letter T with two dots below',
    group: 'Consonants',
  },
  {
    unicode: '\u0074\u0324',
    name: 'Latin Small Letter T with two dots below',
    group: 'Consonants',
  },

  {
    unicode: '\u0179',
    name: 'Latin Capital Letter Z with acute',
    group: 'Consonants',
  },
  {
    unicode: '\u017A',
    name: 'Latin Small Letter Z with acute',
    group: 'Consonants',
  },
  {
    unicode: '\u017B',
    name: 'Latin Capital Letter Z with dot above',
    group: 'Consonants',
  },
  {
    unicode: '\u017C',
    name: 'Latin Small Letter Z with dot above',
    group: 'Consonants',
  },
  {
    unicode: '\u017D',
    name: 'Latin Capital Letter Z with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u017E',
    name: 'Latin Small Letter Z with caron',
    group: 'Consonants',
  },
  {
    unicode: '\u1E92',
    name: 'Latin Capital Letter Z with dot below',
    group: 'Consonants',
  },
  {
    unicode: '\u1E93',
    name: 'Latin Small Letter Z with dot below',
    group: 'Consonants',
  },

  { unicode: '\u00D0', name: 'Latin Capital letter Eth', group: 'Latin' },
  { unicode: '\u00F0', name: 'Latin Small letter Eth', group: 'Latin' },
  { unicode: '\u00DE', name: 'Latin Capital Letter Thorn', group: 'Latin' },
  { unicode: '\u00FE', name: 'Latin Small Letter Thorn', group: 'Latin' },

  { unicode: '\u002B', name: 'Plus sign', group: 'Math' },
  { unicode: '\u2212', name: 'Minus sign', group: 'Math' },
  { unicode: '\u00D7', name: 'Multiplication sign', group: 'Math' },
  { unicode: '\u00F7', name: 'Division sign', group: 'Math' },
  { unicode: '\u002F', name: 'Solidus', group: 'Math' },
  { unicode: '\u003D', name: 'Equals sign', group: 'Math' },
  { unicode: '\u00B1', name: 'Plus-minus sign', group: 'Math' },
  { unicode: '\u003C', name: 'Less than sign', group: 'Math' },
  { unicode: '\u003E', name: 'Greater than sign', group: 'Math' },
  { unicode: '\u2264', name: 'Less than or equal to sign', group: 'Math' },
  { unicode: '\u2265', name: 'Greater than or equal to sign', group: 'Math' },
  { unicode: '\u00B0', name: 'Degree symbol', group: 'Math' },
  { unicode: '\u00B4', name: 'Acute accent', group: 'Math' },
  { unicode: '\u02DD', name: 'Double acute accent', group: 'Math' },
  { unicode: '\u007C', name: 'Vertical line', group: 'Math' },
  { unicode: '\u03C0', name: 'Greek Small Letter Pi ', group: 'Math' },
  { unicode: '\u2211', name: 'N-ary summation', group: 'Math' },

  { unicode: '\u2018', name: 'Left Single Quotation Mark', group: 'Misc' },
  { unicode: '\u2019', name: 'Right Single Quotation Mark', group: 'Misc' },
  { unicode: '\u2026', name: 'Horizontal ellipsis', group: 'Misc' },
  { unicode: '\u2013', name: 'En dash', group: 'Misc' },
  { unicode: '\u2014', name: 'Em dash', group: 'Misc' },
  { unicode: '\u2E3B', name: 'Three-em dash', group: 'Misc' },
  { unicode: '\u2009', name: 'Thin space', group: 'Misc' },
  { unicode: '\u200A', name: 'Hair space', group: 'Misc' },
  { unicode: '\u2002', name: 'En space', group: 'Misc' },
  { unicode: '\u2003', name: 'Em Space', group: 'Misc' },
  { unicode: '\u00A9', name: 'Copyright', group: 'Misc' },
  { unicode: '\u2117', name: 'Sound recording copyright', group: 'Misc' },
  { unicode: '\u2122', name: 'Registered Trademark', group: 'Misc' },
  { unicode: '\u00AE', name: 'Registered sign', group: 'Misc' },
  { unicode: '\u00A1', name: 'Inverted Exclamation Mark', group: 'Misc' },
  { unicode: '\u00BF', name: 'Inverted Question Mark', group: 'Misc' },
  {
    unicode: '\u00AB',
    name: 'Left-pointing double-angle quotation mark',
    group: 'Misc',
  },
  {
    unicode: '\u00BB',
    name: 'Right-pointing double-angle quotation mark',
    group: 'Misc',
  },
  { unicode: '\u00B7', name: 'Middle dot', group: 'Misc' },
  { unicode: '\u00A7', name: 'Section symbol', group: 'Misc' },
  { unicode: '\u00B6', name: 'Pilcrow sign', group: 'Misc' },
  { unicode: '\u2020', name: 'Dagger', group: 'Misc' },
  { unicode: '\u2640', name: 'Female sign', group: 'Misc' },
  { unicode: '\u2642', name: 'Male sign', group: 'Misc' },
  { unicode: '\u00A3', name: 'Pound sign', group: 'Misc' },
  { unicode: '\u00A5', name: 'Yen sign', group: 'Misc' },
  { unicode: '\u20AC', name: 'Euro sign', group: 'Misc' },
  { unicode: '\u00A2', name: 'Cent sign', group: 'Misc' },
  { unicode: '\u2669', name: 'Quarter note', group: 'Misc' },
  { unicode: '\u266A', name: 'Eigth note', group: 'Misc' },
  { unicode: '\u266D', name: 'Flat sign', group: 'Misc' },
  { unicode: '\u266E', name: 'Natural sign', group: 'Misc' },
  { unicode: '\u266F', name: 'Sharp sign', group: 'Misc' },

  // { unicode: '\u00A4', name: 'Currency sign', group: 'Latin-Supplement' },
  // { unicode: '\u00A6', name: 'Broken bar', group: 'Latin-Supplement' },
  // { unicode: '\u00A7', name: 'Section sign', group: 'Latin-Supplement' },
  // { unicode: '\u00A8', name: 'Diaeresis', group: 'Latin-Supplement' },
  // { unicode: '\u00AA', name: 'Feminine Ordinal Indicator', group: 'Latin-Supplement' },
  // { unicode: '\u00AB', name: 'Left-pointing double angle quotation mark', group: 'Latin-Supplement' },
  // { unicode: '\u00AC', name: 'Not sign', group: 'Latin-Supplement' },
  // { unicode: '\u00AD', name: 'Soft hyphen', group: 'Latin-Supplement' },
  // { unicode: '\u00AF', name: 'macron', group: 'Latin-Supplement' },
  // { unicode: '\u00B2', name: 'Superscript two', group: 'Latin-Supplement' },
  // { unicode: '\u00B3', name: 'Superscript three', group: 'Latin-Supplement' },
  // { unicode: '\u00B4', name: 'Acute accent', group: 'Latin-Supplement' },
  // { unicode: '\u00B5', name: 'Micro sign', group: 'Latin-Supplement' },
  // { unicode: '\u00B8', name: 'Cedilla', group: 'Latin-Supplement' },
  // { unicode: '\u00B9', name: 'Superscript one', group: 'Latin-Supplement' },
  // { unicode: '\u00BA', name: 'Masculine ordinal indicator', group: 'Latin-Supplement' },
  // { unicode: '\u00BC', name: 'Vulgar fraction one quarter', group: 'Latin-Supplement' },
  // { unicode: '\u00BD', name: 'Vulgar fraction one half', group: 'Latin-Supplement' },
  // { unicode: '\u00BE', name: 'Vulgar fraction three quarters', group: 'Latin-Supplement' },

  // { unicode: '\u0184', name: 'Latin Capital Letter Tone Six', group: 'Latin-Extended-B' },
  // { unicode: '\u0185', name: 'Latin Small Letter Tone Six', group: 'Latin-Extended-B' },
  // { unicode: '\u0186', name: 'Latin Capital Letter Open O', group: 'Latin-Extended-B' },
  // { unicode: '\u018D', name: 'Latin Small Letter Turned Delta', group: 'Latin-Extended-B' },
  // { unicode: '\u018E', name: 'Latin Capital Letter Reversed E', group: 'Latin-Extended-B' },
  // { unicode: '\u018F', name: 'Latin Capital Letter Schwa', group: 'Latin-Extended-B' }
];
